module.exports = __webpack_public_path__ + "img/login-latola.58069a0f.svg";